import { Mail } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/lib/seo";

const EMAIL = "hello@wgroupconsulting.co.uk";

export default function Contact() {
  usePageMeta(
    "Contact — W Group Consulting",
    "Get in touch with W Group Consulting — email hello@wgroupconsulting.co.uk to discuss your business and how we can support you.",
    "/contact"
  );

  return (
    <>
      <PageHero
        eyebrow="Contact"
        titleLines={["Get in touch"]}
        description="To discuss your business and how W Group can support you, email us at:"
      />
      <section className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-36" data-testid="contact-section">
        <Reveal className="text-center">
          <a
            href={`mailto:${EMAIL}`}
            data-testid="contact-email-link"
            className="break-all font-display text-xl text-ink underline decoration-gold decoration-2 underline-offset-8 transition-colors duration-300 hover:text-gold sm:text-4xl lg:text-5xl"
          >
            {EMAIL}
          </a>
          <p className="mx-auto mt-10 max-w-md text-sm leading-relaxed text-gray-500">
            Tap the address to open your email app, or copy it to write to us
            however you prefer.
          </p>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="contact-email-button"
            className="group mt-10 inline-flex items-center gap-3 bg-gold px-8 py-4 text-sm font-medium tracking-wide text-ink transition-colors duration-300 hover:bg-ink hover:text-paper"
          >
            <Mail size={16} aria-hidden="true" />
            Email us
          </a>
        </Reveal>
      </section>
    </>
  );
}
